import { MonacoEditor } from "./monaco-editor";
import { Text, createStyles } from "@mantine/core";
export interface MonacoProps {
  label: string;
  onChange: (value: string) => void;
  value: string;
  autoComplate: string[];
  isReadonly?: boolean;
  height?: string;
  suggestionsPosition?: string;
}
export const useStyles = createStyles((theme, position: string) => ({
  monacoEditorContainer: {
    ".monaco-editor .suggest-widget": {
      right: position === "left" ? 0 : "initial",
      left: position === "left" ? "initial !important" : 0,
      ".monaco-list .monaco-list-row>.contents": {
        overflow: "initial",
      },
    },
  },
}));
const Monaco = ({ onChange, value, autoComplate, isReadonly, label, height, suggestionsPosition }: MonacoProps) => {
  const { classes } = useStyles(suggestionsPosition ?? "right");
  const autoComplete = (
    model: monaco.editor.ITextModel,
    position: monaco.Position
  ): Promise<monaco.languages.ProviderResult<monaco.languages.CompletionList>> => {
    return new Promise((resolve) => {
      const suggestions: monaco.languages.CompletionItem[] = [];

      const textUntilPosition = model?.getValueInRange({
        startLineNumber: position?.lineNumber,
        startColumn: 1,
        endLineNumber: position?.lineNumber,
        endColumn: position?.column,
      });
      const word = textUntilPosition.replace(/\t/, "").split(/[,{}() @/]+/);

      const activeWord = word[word.length - 1];
      const range = {
        startLineNumber: position?.lineNumber,
        endLineNumber: position?.lineNumber,
        startColumn: position?.column - activeWord.length,
        endColumn: position?.column,
      };
      autoComplate.map((t) => {
        const insertText = textUntilPosition.includes("@") ? t.replace(textUntilPosition, "") : t;
        suggestions.push({
          label: t,
          kind: monaco.languages.CompletionItemKind.Field,
          range: range,
          insertText: insertText,
        });
      });
      resolve({
        incomplete: true,
        suggestions: suggestions,
      });
    });
  };
  return (
    <>
      <Text fz="sm" fw={500} pb={2}>
        {label}
      </Text>
      <div style={{ border: "1px solid #ced4da" }}>
        <MonacoEditor
          className={classes.monacoEditorContainer}
          width="100%"
          height={height ? height : 100}
          value={value}
          onChange={(val) => {
            onChange(val);
          }}
          language="infoveave-markdown"
          autoComplete={(model, position) => autoComplete(model, position)}
          options={{
            scrollBeyondLastLine: !(isReadonly ?? false),
          }}
        />
      </div>
    </>
  );
};

export default Monaco;
